import { useEffect, useState } from 'react';
import './App.css';

const projects = [
  {
    title: 'Ludo & Callbreak Games',
    stack: 'Unity • C# • Multiplayer Game Logic',
    link: 'https://play.google.com/store/apps/details?id=com.gamekunda.games.ludo',
  },
  {
    title: 'Gamekunda.com',
    stack: 'Web Development • UI Design • Responsive Website',
    link: 'https://gamekunda.com',
  },
  {
    title: '365 Home Loan Website',
    stack: 'React • Frontend Development • Business Website',
    link: 'http://365homeloans.com.au/',
  },
  {
    title: 'E-commerce Website',
    stack: 'Web Development • Product UI • Shopping Flow',
    link: 'https://lalitpureyecarecenter.com.np',
  },
  {
    title: 'College Portfolio',
    stack: 'React • Portfolio Design • Personal Branding',
  },
  {
    title: 'Color Blind Test App',
    stack: 'Mobile App • UI Flow • User Testing',
    link: 'https://play.google.com/store/apps/details?id=com.gamekunda.applications.colorblindtest',
  },
];

function App() {
  const [theme, setTheme] = useState('light');

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
  }, [theme]);

  return (
    <div className="app-shell">
      <div className="ambient ambient-one" />
      <div className="ambient ambient-two" />

      <header className="hero-panel">
        <nav className="navbar">
          <a className="brand" href="#top">
            <span className="brand-mark">{'</>'}</span>
            <span>Sp Sharma</span>
          </a>

          <div className="nav-tools">
            <div className="nav-links">
              <a href="#about">About</a>
              <a href="#skills">Skills</a>
              <a href="#projects">Projects</a>
              <a href="#contact">Contact</a>
            </div>

            <button
              className="theme-toggle"
              type="button"
              onClick={() => setTheme((currentTheme) => (currentTheme === 'dark' ? 'light' : 'dark'))}
              aria-label={`Switch to ${theme === 'dark' ? 'light' : 'dark'} theme`}
            >
              <span className="theme-icon" aria-hidden="true">
                {theme === 'dark' ? '☀' : '☾'}
              </span>
            </button>
          </div>
        </nav>

        <section className="hero" id="top">
          <div className="hero-copy">
            <p className="eyebrow">Software Developer</p>
            <h1>I build simple and clean digital experiences.</h1>
            <p className="hero-text">
              I enjoy coding, building projects, and improving user interfaces with
              modern web technologies.
            </p>

            <div className="hero-actions">
              <a className="button button-primary" href="#projects">
                View Projects
              </a>
              <a className="button button-secondary" href="#contact">
                Let&apos;s Work Together
              </a>
            </div>
          </div>

          <aside className="hero-card" aria-label="Developer snapshot">
            <div className="terminal-bar">
              <span />
              <span />
              <span />
            </div>
            <div className="terminal-content">
              <p>$ whoami</p>
              <p className="terminal-answer">sp_sharma</p>
              <p>$ role</p>
              <p className="terminal-answer">software developer</p>
              <p>$ stack</p>
              <p className="terminal-answer">react, javascript, unity, c#</p>
            </div>
          </aside>
        </section>
      </header>

      <main className="main-content">
        <section className="section simple-grid" id="about">
          <div className="section-heading">
            <p className="section-tag">About Me</p>
            <h2>I like creating useful projects and writing better code every day.</h2>
          </div>

          <div className="about-card">
            <p>
              I am interested in software development, game development, and web
              design. I enjoy building projects that are simple, modern, and easy to use.
            </p>
          </div>
        </section>

        <section className="section" id="skills">
          <div className="section-heading">
            <p className="section-tag">Skills</p>
            <h2>Technologies I use.</h2>
          </div>

          <div className="stack-list simple-stack">
            <span>React</span>
            <span>JavaScript</span>
            <span>CSS</span>
            <span>Node.js</span>
            <span>Unity</span>
            <span>C#</span>
            <span>GitHub</span>
            <span>Vercel</span>
          </div>
        </section>

        <section className="section" id="projects">
          <div className="section-heading">
            <p className="section-tag">Projects</p>
            <h2>Some of my work.</h2>
          </div>

          <div className="projects-grid">
            {projects.map((project) => (
              <article className="project-card" key={project.title}>
                <h3>{project.title}</h3>
                <p>{project.stack}</p>
                {project.link ? (
                  <a
                    className="project-link"
                    href={project.link}
                    target="_blank"
                    rel="noreferrer"
                  >
                    View Project
                  </a>
                ) : null}
              </article>
            ))}
          </div>
        </section>

        <section className="section contact-panel" id="contact">
          <div>
            <p className="section-tag">Contact</p>
            <h2>Let&apos;s connect.</h2>
            <p>Open for projects, internships, and collaboration.</p>
          </div>

          <div className="contact-card">
            <p>Email</p>
            <a href="mailto:satyasharma.dev@gmail.com">satyasharma3000@gmail.com</a>
            <p>GitHub</p>
            <a href="https://github.com/sp-sharma/" target="_blank" rel="noreferrer">
              github.com/sp-sharma
            </a>
            <p>LinkedIn</p>
            <a
              href="https://www.linkedin.com/in/satya-sharma-2bb63623a/"
              target="_blank"
              rel="noreferrer"
            >
              linkedin.com/in/satya-sharma-2bb63623a
            </a>
          </div>
        </section>
      </main>

      <footer className="footer">
        <p>© 2026 Sp Sharma. Passionate about coding, programming, and building useful digital products.</p>
      </footer>
    </div>
  );
}

export default App;
